/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const FileVideoIconConfig = {
  name: 'FileVideoIcon',
  height: 512,
  width: 384,
  svgPath: 'M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM224 136V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248c-13.2 0-24-10.8-24-24zm96 144.016v111.963c0 21.445-25.943 31.998-40.971 16.971L224 353.941V392c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V280c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v38.059l55.029-55.013c15.011-15.01 40.971-4.491 40.971 16.97z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(FileVideoIconConfig);
//# sourceMappingURL=file-video-icon.js.map